import { DependencyList, EffectCallback, useEffect } from 'react'

const useTruthyEffect = (effect: EffectCallback, deps: DependencyList) => {
  useEffect(() => {
    if (deps.reduce((r, e) => ((Array.isArray(e) && e.length > 0) || (!Array.isArray(e) && Boolean(e))) && r, true)) {
      effect()
    }
  }, deps)
}

export default useTruthyEffect
